
























































import {
  Component,
  Vue,
  Prop,
  Emit,
} from 'vue-property-decorator';
import AuthConnector from '@/connector/Auth.vue';
import UserService from '@/services/UserService';
import RegisterForm from '@/components/RegisterForm.vue';

interface RegisterFormData {
  username: string;
  password: string;
  accountNumber: string;
  bank: string;
  accountName: string;
  lineId?: string;
  knownUsFrom: string;
  ref_code?: string;
}

@Component({
  components: {
    AuthConnector,
    RegisterForm,
  },
})
export default class LoginDialog extends Vue {
  @Prop({ type: Boolean, required: true }) open: boolean|undefined;

  public loading: boolean = false;

  private userService = new UserService();

  public async registerUser(loginFunction: any) {
    try {
      const refCode = await localStorage.getItem('ufa-auto-reference');
      this.loading = true;
      // eslint-disable-next-line max-len
      const data = (this.$refs.REGISTER_FORM as Vue & { getFormData: () => RegisterFormData }).getFormData();
      await this.userService.registerUser({
        username: data.username,
        password: data.password,
        accountNumber: data.accountNumber,
        bank: data.bank,
        accountName: data.accountName,
        lineId: data.lineId,
        // eslint-disable-next-line @typescript-eslint/camelcase
        ref_code: refCode,
        knownUsFrom: data.knownUsFrom,
      });
      this.loading = false;
      this.$store.commit('Snackbar/showNotification', { message: 'สมัครสามาชิกสำเร็จ', error: false });
      (this.$refs.REGISTER_FORM as Vue & { resetFormData: () => void }).resetFormData();
      this.$store.dispatch('Dialog/updateDialog', { open: false, dialogType: '' });
      loginFunction({ username: data.username, password: data.password });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
      this.loading = false;
    }
  }

  get dialog() {
    return this.open;
  }

  set dialog(value) {
    this.close();
  }

  @Emit('close-dialog')
  // eslint-disable-next-line class-methods-use-this
  close() {
    return false;
  }
}
